import React from 'react'
import { Button } from "@material-ui/core";

import {
    PopupTitle,
    PopupContainer,
    PopupDescription,
    TitleContainer
} from "../CandidateView.styles";

interface ShowContactsConfirmationProps {
    onConfirm: () => void,
    name: string
}

const ShowContactsConfirmation = ({
    onConfirm,
    name
}: ShowContactsConfirmationProps) => {
    return (
        <PopupContainer>
            <TitleContainer><PopupTitle>Contact Details shared</PopupTitle></TitleContainer>
            <PopupDescription>
                {name} can now see your contact details.
            </PopupDescription>
            <Button
                variant="contained"
                onClick={onConfirm}
                color="primary"
                size="large"
                id="confirm-button"
                className="bigButtonInNewStyle"
            >
                OK
            </Button>
        </PopupContainer>
    )
}

export default ShowContactsConfirmation;
